import React, { useState } from 'react';
import Header from '../../components/header';
import TimezoneInfo from '../../components/timezoneInfo';
import ReloadButton from '../../components/reloadButton';
import NotificationTools from '../../components/notificationTools';

import PortalsContainer from '../../containers/portals';

const PortalsScreen = () => {
  const [lastUpdated, setLastUpdated] = useState('');

  return (
    <div className="d-flex flex-column flex-fill">
      <Header
        title={'Brand'}
        icon={'tag'}
        actions={[
          { type: 'reactComponent', value: <TimezoneInfo key="timezone-info" /> },
          {
            type: 'reactComponent',
            value: <ReloadButton key="reload-btn" contentName="Portals data" lastUpdatedCB={setLastUpdated} />
          },
          { type: 'reactComponent', value: <NotificationTools key="notification-btn" /> }
        ]}
      />
      <PortalsContainer lastUpdated={lastUpdated} />
    </div>
  );
};

export default PortalsScreen;
